import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import AwardListLayer from "../components/AwardListLayer";

const AwardListPage = () => {
  return (
    <>
      <MasterLayout>
        <AwardListLayer />
      </MasterLayout>
    </>
  );
};

export default AwardListPage;
